module.exports = __webpack_public_path__ + "img/store-play-id.7648505.png";